mutation updateCompanyAmbassadorSignatureIncludeProvenExpert($input: UpdateCompanyAmbassadorSignatureIncludeProvenExpertInput!) {
  updateCompanyAmbassadorSignatureIncludeProvenExpert(input: $input)
}
